var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCompanySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1083,
    height: 300,
    viewBox: "0 0 1083 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5b5b5b;}.b,.d{fill:#fff;}.c{clip-path:url(#a);}.d{font-size:41px;font-family:SegoeUI, Segoe UI;opacity:0.93;}.e{fill:#b02318;}.f{clip-path:url(#b);}.g{fill:#ffbcbc;}.h{fill:none;stroke:#ee5050;stroke-width:0.87px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1083,
    height: 300,
    rx: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 416,
    height: 300
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-436 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(436 188)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1083,
    height: 300,
    rx: 10
  })), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(724 350)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -185.651,
    y: 0
  }, "Welcome to Sen"), /*#__PURE__*/React.createElement("tspan", {
    className: "e",
    y: 0
  }, "db"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "iz")), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(986.999 188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.173 -16.059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 134.617)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.579 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.755 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.177 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.31 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.445 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.134 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.531 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.177 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.665 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.354 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(259.842 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.045 45.916)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.487 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.665 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.798 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.178 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.355 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 90.722)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.621 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.798 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.178 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.312 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.487 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,0,50.09,21.914,37.568,43.829H12.523L0,21.914,12.523,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 21.914, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.479,
    y2: 6.261,
    transform: "translate(21.168 22.631)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y2: 5.218,
    transform: "translate(32.647 23.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 13.566,
    transform: "translate(32.647 28.892)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.001 178.445)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.134 90.723)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.531 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.177 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.665 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.354 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(259.841 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.045 44.808)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.487 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.664 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.797 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.177 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.355 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.797)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.177)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.312)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.487)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.568,43.829,50.09,21.914,37.568,0H12.523L0,21.914,12.523,43.829Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 6.261,
    x2: 11.479,
    transform: "translate(21.168 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 11.479,
    y1: 5.218,
    transform: "translate(32.647 34.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    y1: 13.566,
    transform: "translate(32.647 20.543)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCompanySmall);
export default __webpack_public_path__ + "static/media/edit-company-small.794f8e2189fec9f08f510d05ee981fd2.svg";
export { ForwardRef as ReactComponent };